import React, {useEffect} from 'react';
import * as actions from '../actions';

export function DashboardOperationsCalendar() {

	useEffect(() => { actions.setHeader({
		key: 'dashboardOperationsHeader',
		component: (
			<header><ul className="menu"><li><a className="button" href="dashboardOperationsJobs"><span><span className="statusDot"></span>Jobs</span></a></li><li><a className="button on" href="dashboardOperationsCalendar"><span>Calendar</span></a></li><li><a className="button" href="dashboardOperationsPersonnel"><span>Personnel</span></a></li></ul></header>
		)
	});

	return () => {
		actions.deleteHeader({ key: 'dashboardOperationsHeader'});
	}
	}, []);

	return <div className='dashboard operations'>

		<section className='expander collapsed'>
			<header>
				<span>5/25-5/31<span className='subtitle'>$22,000 / $28,000</span></span>
			</header>
		</section>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span>MON 5/25<span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''></div>
		</section>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span>TUE 5/26<span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''></div>
		</section>

		<section className='expander expanded'>
			<header><button tabIndex={1}><span>WED 5/27 <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>DELIVERY <span className='subtitle'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
					</header>
					<div>
						<div className='inner clearfix'>
							<table className='sortable interactive' cellPadding='0' cellSpacing='0'>
								<thead>
									<tr>
										<td></td>
										<td className='sorted'>Legacy ID</td>
										<td className='name'>Client</td>
										<td className='address'>Address</td>
										<td className='name'>Installer</td>
										<td className='count'></td>
										<td className='count'></td>
										<td className=''>Occupied?</td>
										<td className='action'></td>
										<td></td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td></td>
										<td>000000</td>
										<td className='name'>Dana Carver</td>
										<td className='address'>225 E. Windmere</td>
										<td className='name'>N. Nickerson</td>
										<td className='count'></td>
										<td className='count'></td>
										<td className=''>Yes</td>
										<td className='action navigate'></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>

				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>SERVICE <span className='subtitle'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
					</header>
					<div>
						<div className='inner clearfix'>
							<table className='sortable interactive' cellPadding='0' cellSpacing='0'>
								<thead>
									<tr>
										<td></td>
										<td className='sorted'>Legacy ID</td>
										<td className='name'>Client</td>
										<td className='address'>Address</td>
										<td className='name'>Service Tech</td>
										<td className='count'>Issues</td>
										<td className='count'>Estimate</td>
										<td className=''>Occupied?</td>
										<td className='action'></td>
										<td></td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td></td>
										<td>000000</td>
										<td className='name'>Dana Carver</td>
										<td className='address'>225 E. Windmere</td>
										<td className='name'>N. Nickerson</td>
										<td className='count'>1</td>
										<td className='count'>4 hours</td>
										<td className=''>Yes</td>
										<td className='action navigate'></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>
			</div>
		</section>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span>THU 5/28<span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''></div>
		</section>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span>FRI 5/29<span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''></div>
		</section>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span>SAT 5/30<span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''></div>
		</section>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span>SUN 5/31<span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''></div>
		</section>
		
		<section className='expander collapsed'>
			<header>
				<span>6/1-6/6<span className='subtitle'>$14,000 / $28,000</span></span>
			</header>
		</section>
	</div>;
}




